module.exports = __webpack_public_path__ + "img/iphonex-talk-bg.f9c18336.png";